export default "__VITE_ASSET__DA$vqoL8__"